import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CreateInnerCard from './CreateInnerCard';
import InnerCard from './InnerCard';
import { innerCircleLoad } from '../../redux/slices/inner.slice';
import { Pagination, Select } from 'antd';
import { emptySpaceInputHandler } from '../../utils';
import { debounce } from '../../utils/global-func';
import images from '../../themes/appImage';

let LIST_LIMIT = 10
let OFFSET = 0
const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]
const MyinnerCirle = ({ myid }) => {
    const dispatch = useDispatch();
    const [currentPage] = useState(1);
    const [pageSize] = useState(40);
    const { innerCircle, isDeleteSuccess, createInnerCircleSucceeded, isEditSuccess, innerFileUploadSuccess } = useSelector((state) => state.InnerCircleReducer);
    const [searchText, setSearchText] = useState('');
    const [search, setSearch] = useState("")
    console.log(isEditSuccess, "edit");
    useEffect(() => {
        let data;
        if (searchText !== '') {
            data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: searchText,
                order: -1,
                organisation: myid
            };
        } else {
            // If no search query, use the default pageSize and currentPage
            data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: '',
                order: -1,
                organisation: myid
            };
        }
        dispatch(innerCircleLoad(data));
    }, [dispatch, currentPage, pageSize, searchText]);

    useEffect(() => {
        if (createInnerCircleSucceeded || isDeleteSuccess || isEditSuccess || innerFileUploadSuccess) {
            const data = {
                offset: (currentPage - 1) * pageSize,
                limit: pageSize,
                search: '',
                order: -1,
                organisation: myid
            };
            dispatch(innerCircleLoad(data));
        }
    }, [createInnerCircleSucceeded, isDeleteSuccess, isEditSuccess, innerFileUploadSuccess])

    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [innerCircle?.getList]);
    const TOTAL_LIST_ITEMS = useMemo(() => innerCircle.pagination?.totalCount, [innerCircle?.getList])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [innerCircle?.getList]);
    const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS
    // --A C T I O N S--

    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                organisation: myid
            }
            dispatch(innerCircleLoad(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                organisation: myid
            }
            dispatch(innerCircleLoad(data));
        }
    }, [innerCircle?.getList])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            organisation: myid

        }
        dispatch(innerCircleLoad(data));
    }, [innerCircle?.getList])

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                organisation: myid

            }
            debounce(() => dispatch(innerCircleLoad(data)))
        }
    }, [innerCircle?.getList]);

    return (
        <div className="content-e outter-space">
            <div className="user-heading">
                <h1>Inner Circle</h1>
                {/* <button onClick={() => setModal1Open(true)}>Create Inner Circle</button> */}
            </div>
            <div class="bg-gradient-primary inner-cricle-border">
                <input type="text" className="iocn-search  search-bar" placeholder="Search Inner circle" value={search} onChange={searchHandler} />
            </div>

            <div className='mx-2 my-3'>
                <div className="grid grid-cols-4 gap-4 pb-[30px] sm:grid-cols-1  md:grid-cols-2">
                    <CreateInnerCard myid={myid} />

                    {innerCircle?.getList?.length > 0 ?
                        innerCircle?.getList?.map(circle => (
                            <InnerCard
                                id={circle._id}
                                key={circle._id}
                                name={circle.name}
                                dec={circle.description}
                                memberUserList={circle.circleMembers || []}
                                myid={myid}
                            />
                        )) : <div className='flex justify-center items-center w-48 p-4 rounded-md bg-white font-semibold text-sm h-32'>No data found</div>}

                </div>

                {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                    <div className="foot-main-div">
                        <div className="rows">
                            <div className="row-per-page">
                                <p>Rows per page</p>
                            </div>
                            <div className="top-checkbox fot-select">
                                <Select
                                    defaultValue={LIST_LIMIT}
                                    onChange={numberOfRowHandler}
                                    options={numberOfRowOptionList}
                                />
                            </div>
                        </div>

                        <div className="page-count">
                            <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                        </div>

                        <div className="back-and-next">
                            {/* <span><img src={images.back} alt="back" /></span> */}
                            <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                            <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                            {/* <span><img src={images.next} alt="back" /></span> */}
                        </div>

                    </div>

                </div>}
            </div>

        </div>
    )
}

export default MyinnerCirle;